<template>
  <div id="my-lists">
    <page-title v-bind:title="pageTitle"></page-title>
    <new-list-modal></new-list-modal>

    <tabs :tabs="tabs" v-model="currentTab"></tabs>
    <div class="my-lists" v-if="!emptyState">
      <list-item
        v-for="list in userLists"
        v-bind:key="list.id"
        :list="list"
        :userId="userId"
      ></list-item>
      <add-button
        :act="openNewListModal"
        title="Create new session"
      ></add-button>
    </div>

    <empty-state
      v-if="emptyState"
      v-bind:callToAction="callToAction"
      v-bind:image="emptyStateImage"
      v-bind:description="emptyStateDescription"
      v-bind:act="openNewListModal"
      v-bind:primary="true"
    ></empty-state>
  </div>
</template>

<script>
import NewListModal from "../components/NewList.vue";
import PageTitle from "../components/PageTitle.vue";
import EmptyState from "../components/EmptyState.vue";
import AddButton from "../components/AddButton.vue";
import ListItem from "../components/lists/ListItem";
import Tabs from "@/components/shared/Tabs";

import bus from "../bus";
import store from "../store/store";

export default {
  components: {
    NewListModal,
    PageTitle,
    EmptyState,
    AddButton,
    ListItem,
    Tabs,
  },
  data() {
    return {
      pageTitle: "Brainstorming Sessions",
      callToAction: "Create new session",
      emptyStateDescription:
        "It seems a bit empty in here. Why don’t you create a new brainstorming session, so you gather brilliant ideas and valuable feedback?",
      emptyStateImage: "undraw_team_spirit.svg",
      currentTab: 0,
    };
  },
  computed: {
    tabs() {
      return [
        {
          title: 'Open',
          status: 'active',
          number: this.$store.state.userLists 
                  ? this.$store.state.userLists.filter(list => list.status === 'active').length 
                  : 0
        },
        {
          title: 'Concluded',
          status: 'concluded',
          number: this.$store.state.userLists 
                  ? this.$store.state.userLists.filter(list => list.status === 'concluded').length 
                  : 0
        }
      ];
    },
    userId() {
      return this.$store.state.user.id;
    },
    userLists: {
      get: function () {
        bus.$emit("hide-loader");
        return this.$store.state.userLists 
                && (
                    this.$store.state.userLists.length
                    ? this.$store.state.userLists.filter(e => e.status == this.tabs[this.currentTab].status)
                    : this.$store.state.userLists
                );
      },
      set: function (lists) {
        store.dispatch("fetchUserLists", lists);
      },
    },
    emptyState() {
      if (this.userLists) {
        return this.userLists.length == 0;
      } else {
        return true
      }
    },
  },
  methods: {
    newListEvent: function () {
      bus.$on("list-created", (newlist) => {
        let lists = JSON.parse(JSON.stringify(this.userLists));
        lists.unshift(newlist);
        this.userLists = lists;
      });
    },
    removeListEvent: function () {
      bus.$on("remove-list", (listId) => {
        let lists = JSON.parse(JSON.stringify(this.userLists));
        for (let i = 0; i < lists.length; i++) {
          if (lists[i].id == listId) {
            lists.splice(i, 1);
            break;
          }
        }
        this.userLists = lists;
      });
    },
    openNewListModal: function () {
      bus.$emit("new-list-mode");
    },
  },
  beforeMount: function () {
    this.newListEvent();
    this.removeListEvent();
    bus.$emit("show-loader", "");
  },
};
</script>

<style scoped lang="scss">
@use '../styles/theme';

.my-lists {
  margin-top: 40px;
  margin-bottom: 60px;
}
.my-lists .list-container {
  padding: 0;
}

@media (min-width: 900px) {
  .my-lists .list-container {
    width: calc(50% - 10px);
  }
  .my-lists .list-container:nth-child(odd) {
    margin-right: 19px;
  }
}
</style>